import React from "react";
import { CardListPageContent } from "../../Components/TemplateList/CardListContent";
import { getAllUrlParams } from "../../../lib/common";
const CardListPage = ({ category }) => {
    const urlParams = getAllUrlParams(location.search);
    if (urlParams.category) {
        category = urlParams.category.toUpperCase();
    }
    return React.createElement(CardListPageContent, { category: category });
};
export default CardListPage;
